import React, { useRef, useState } from 'react'

import SignatureCanvas from 'react-signature-canvas'

export default function TesteBox () {

  const assinaturaCanvas = useRef( null )
  const [trimmedAssinatura, setTrimmedAssinatura] = useState( null )

  const trim = () => {
    //@ts-ignore
    console.log( assinaturaCanvas.current.toDataURL().length )
    
    //@ts-ignoregetTrimmedCanvas
    // setTrimmedAssinatura( assinaturaCanvas.current.getTrimmedCanvas().toDataURL( 'image/png' ) )
  }

  return ( <>


    <h1>TesteBox</h1>

    <SignatureCanvas penColor='blue'
      ref={assinaturaCanvas}
      canvasProps={{ width: 500, height: 200 }} />

      <button onClick={trim}>Trim</button>

  </> )
}


/*
import React, { useState } from 'react'
import PedidosPagamentosPersonalizar from '../View/Crud/Pedido/PedidosPagamentosPersonalizar'
import { PedidoPagamentoPersonalizadoInterface } from '../ImportBackend/Interfaces/PedidoInterfaces'

export default function TesteBox () {

  const onConfirmarAlteracaoDatasEValores = ( rs: Array<PedidoPagamentoPersonalizadoInterface> ) => {
    console.log( rs )
  }

  const [rsExibirPagamentoPersonalizado, setRsExibirPagamentoPersonalizado] = useState<boolean>( true )

  const datas: Array<PedidoPagamentoPersonalizadoInterface> = [{
    data: '2024-11-30',
    valor: 100,
  },
  {
    data: '2024-12-30',
    valor: 100,
  }]

  return (
    <>
      <PedidosPagamentosPersonalizar
        onConfirmarAlteracaoDatasEValores={onConfirmarAlteracaoDatasEValores}
        dados={datas}
        exibir={rsExibirPagamentoPersonalizado}
        setExibir={setRsExibirPagamentoPersonalizado}
        valorTotal={200}
      />
    </>
  )
}
  */